var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-content ofh"},[_c('g-header'),_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"pageContent"},[_c('el-row',[_c('el-col',{attrs:{"span":24}},[_vm._t("default")],2)],1)],1)]),_c('g-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }